import type { PropsWithChildren } from "react";
import { Icon } from "@/react/components/shared/Icon";
import { TippyV2 } from "@/react/components/shared/TippyV2";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface ListProps {
  className?: string;
  title: string;
  tooltipText?: string;
}

export const List = ({
  title,
  tooltipText,
  children,
  className,
}: PropsWithChildren<ListProps>) => (
  <div className={classNames("flex flex-col gap-y-3", className)}>
    <div className="flex flex-row items-center gap-x-2">
      <Typography.LabelSm weight="semibold">{title}</Typography.LabelSm>
      {tooltipText && (
        <TippyV2 content={tooltipText}>
          <Icon
            type="question-mark"
            className="!w-[11px]"
            viewBox="0 0 25 25"
          />
        </TippyV2>
      )}
    </div>
    <div className="flex flex-col gap-y-1">{children}</div>
  </div>
);
